export default __webpack_public_path__ + "static/international-metric-mobile-fdc074e90156aaec60b21daefa0f7f99.svg";